<template>
  <div class="preview-buttons">
    <div v-for="(item, index) in imageTypes" :key=index>
      <v-btn class="mb-5 ml-5 preview-btn" small rounded color="secondary" :dark="!disabled" @click.stop="showPhotoSwipe(item.type)" :disabled="disabled">
        {{item.name}}画像プレビュー
      </v-btn>
    </div>
    <v-photo-swipe
      :isOpen="isOpen && selectedPreviewImage && selectedPreviewImage.length !== 0"
      :items="selectedPreviewImage || []"
      :options="photoswipeOptions"
      @close="hidePhotoSwipe" />
  </div>
</template>

<script>
import VPhotoSwipe from '@/components/atoms/PhotoSwipe'

export default {
  components: {
    VPhotoSwipe,
  },
  props: {
    previewImages: {
      type: Object,
      default: () => {
        return {
          question: { name: '問題', data: [] },
          answer: {name: '解答', data: [] },
        }
      }
    },
    disabled:{
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    isOpen: false,
    imageTypes: [
      { name: "問題", type: "question"},
      { name: "解答", type: "answer"},
    ],
    type: 'question',
    photoswipeOptions: {
      index: 0,
    },
  }),

  computed: {
    selectedPreviewImage() {
      if (!this.previewImages || !this.previewImages[this.type]) return null
      return this.previewImages[this.type].data
    }
  },

  methods: {
    showPhotoSwipe(type) {
      this.type = type
      this.$emit('open', type)
      this.isOpen = true
    },
    hidePhotoSwipe(){
      this.isOpen = false
    },
  }
}
</script>

<style lang="stylus" scoped>
.preview-buttons
  display flex
</style>
